import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LmCustomerSettings } from 'src/app/models/lm-customer-settings';
import { TraxCustomer } from 'src/app/models/trax-customer';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private selectedCustomerId: number;
  private _lmCustomerSettings: BehaviorSubject<LmCustomerSettings> = new BehaviorSubject<LmCustomerSettings>(new LmCustomerSettings());
  public readonly LmCustomerSettings: Observable<LmCustomerSettings> = this._lmCustomerSettings.asObservable();

  constructor(private http: HttpClient) { }

  getCustomersForUser(): Observable<TraxCustomer[]> {
    return this.http.get<TraxCustomer[]>(`${environment.traxFtlApiServerUrl}/usercustomers`);
  }
  getIsBetaGroup(): Observable<any> {
    return this.http.get<any>(`${environment.traxFtlApiServerUrl}/lookups/isbetagroup`);
  }
  getSelectedCustomerId(): number {
    return this.selectedCustomerId;
  }
  setLmCustomerTraxSettings(customerId: number): void {
    this.selectedCustomerId = customerId;
    let LmCustomerSettingss = this.http.get<LmCustomerSettings>(`${environment.traxApiServerUrl}/Utils/GetLmCustomerTraxSettings/${customerId}`);
    LmCustomerSettingss.subscribe(r => this._lmCustomerSettings.next(r));
  }
}
